import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Building"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 1.5H21C21.8281 1.50083 22.4992 2.17192 22.5 3V22.5H1.5V12C1.50083 11.1719 2.17192 10.5008 3 10.5H10.5V3C10.5008 2.17192 11.1719 1.50083 12 1.5ZM13.5 5.25H15V6.75H13.5V5.25ZM18 5.25H19.5V6.75H18V5.25ZM15 9.75H13.5V11.25H15V9.75ZM18 9.75H19.5V11.25H18V9.75ZM15 14.25H13.5V15.75H15V14.25ZM18 14.25H19.5V15.75H18V14.25ZM6.75 21V15.75H9.75V21H6.75ZM11.25 21H21V3H12V12H3V21H5.25V15C5.25 14.5858 5.58579 14.25 6 14.25H10.5C10.9142 14.25 11.25 14.5858 11.25 15V21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Building.vue"]]);
